import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { MethodSection } from './components/MethodSection';
import { SkillsSection } from './components/SkillsSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-full w-full bg-ink-950 font-sans text-white antialiased" data-id="element-0" data-mp="2wjql9i09eorx">
      <noscript data-id="element-1" data-mp="28tw4wqgqei2x">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="28te1n9vnj3li" />
      </noscript>
      <UrgencyBar data-id="element-3" data-mp="3ijfthv617oci" />
      <Hero data-id="element-4" data-mp="3ihuyy5jpw5en" />
      <main data-id="element-5" data-mp="3mlj8gtrwtb2j">
        <HookSection data-id="element-6" data-mp="3mlatmwc87vop" />
        <PainSection data-id="element-7" data-mp="3mkhm3t5g125i" />
        <MethodSection data-id="element-8" data-mp="3mjztd6hzp62c" />
        <SkillsSection data-id="element-9" data-mp="3mj6hxs835sdv" />
        <OfferSection data-id="element-10" data-mp="3rcj2nr9n9f1c" />
        <FaqSection data-id="element-11" data-mp="3rdas0kcnegj6" />
        <GuaranteeSection data-id="element-12" data-mp="3rcsxbs5mwadd" />
      </main>
      <Footer data-id="element-13" data-mp="5yh2n2cyzbp" />
    </div>;
}